const urlJoin = require('url-join');

const siteLink = 'https://www.chientai.com.tw';

const normalizeUrl = (url) => url.replace(/ /g, '').toLowerCase();

exports.createSiteLink = (locale, p, includeDomain = false) => {
    const url = locale === 'zh-hant' ? p : urlJoin('/', locale, p);
    if (includeDomain) {
        const fullUrl = urlJoin(siteLink, url);
        if (fullUrl.slice(-1) !== '/') {
            return `${fullUrl}/`;
        }
        return fullUrl;
    }
    return url;
};

exports.allCategoriesUri = '/products/';
exports.genCategoryUrl = (category) => urlJoin('/products', category);
exports.genProductUrl = (category, product) => urlJoin('/products', category, normalizeUrl(product));
exports.genProductSpecDetailUrl = (category, product, specDetail) => urlJoin('/products', category, normalizeUrl(product), normalizeUrl(specDetail));
exports.allNewsUrl = '/news/';
exports.genNewsUrl = (url) => urlJoin('/news', normalizeUrl(url));
exports.allAnnouncementUrl = '/announcement/';
exports.genAnnouncementUrl = (url) => urlJoin('/announcement', normalizeUrl(url));
exports.aboutUrl = '/about/';
exports.contactUrl = '/contact/';
